import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/authentication/login/login.service';
import { ResetPasswordComponent } from 'src/app/authentication/reset-password/reset-password.component';
import { MatOverlayService } from 'src/app/services/mat-overlay.service';

@Component({
  selector: 'app-modulos-profile',
  templateUrl: './modulos-profile.component.html',
  styleUrls: ['./modulos-profile.component.css']
})
export class ModulosProfileComponent implements OnInit {
  usuario: any;
  primeiroNome = "Usuário";

  constructor(
    private loginService: LoginService,
    private router: Router,
    private dialog: MatDialog,
    private overlayService: MatOverlayService
  ) { }

  ngOnInit(): void {
    this.usuario = JSON.parse(localStorage.getItem('user'));
    if (this.usuario && this.usuario.nome) {
      this.primeiroNome = this.usuario.nome.split(' ')[0];
    }
  }

  goToProfile() {
    this.closeOverlay();
    this.router.navigate(['/perfil']);
  }

  logOut() {
    this.closeOverlay();
    localStorage.clear();
    this.router.navigate(['/']);
  }

  openResetPasswordDialog() {
    this.closeOverlay();
    this.dialog.open(ResetPasswordComponent, {
      width: '400px',
    });
  }

  closeOverlay() {
    this.overlayService.close();
  }
}

